module.exports = __webpack_public_path__ + "static/img/blog-list-image-2.631fd09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog-list-image-2.jpg
// module id = OAA6
// module chunks = 0